import React from "react";
import { Box, Typography } from "@mui/material";
import RestaurantMenuRoundedIcon from "@mui/icons-material/RestaurantMenuRounded";

import { DEFAULT_BRAND_THEME } from "../themeTokens";

export default function BrandedImageFallback({
  label = "",
  icon,
  brandTheme = DEFAULT_BRAND_THEME,
  className = "",
  sx = {},
}) {
  const c = brandTheme;

  return (
    <Box
      className={className}
      role={label ? "img" : undefined}
      aria-label={label || undefined}
      aria-hidden={label ? undefined : true}
      sx={{
        width: "100%",
        height: "100%",
        minHeight: 120,
        position: "relative",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        p: 2,
        color: c.accent,
        background: `linear-gradient(145deg, ${c.background} 0%, ${c.surface} 100%)`,
        "&::before": {
          content: '""',
          position: "absolute",
          inset: 0,
          background: `linear-gradient(160deg, ${c.primary} 0%, transparent 48%, ${c.cta} 140%)`,
          opacity: 0.16,
          pointerEvents: "none",
        },
        ...sx,
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: 50,
          height: 50,
          borderRadius: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: c.surface,
          border: "1px solid rgba(124,45,18,0.12)",
          boxShadow: "0 14px 32px rgba(33,20,12,0.10)",
        }}
      >
        {icon || <RestaurantMenuRoundedIcon />}
      </Box>

      {label ? (
        <Typography
          variant="caption"
          sx={{
            position: "relative",
            maxWidth: "100%",
            color: c.muted,
            fontWeight: 850,
            textAlign: "center",
            lineHeight: 1.25,
          }}
        >
          {label}
        </Typography>
      ) : null}
    </Box>
  );
}
